import { formatChartValue } from '../chartFormatting'
import type { MetricUnit } from '../types'

/**
 * Signed percent for a non-null value, e.g. "+18.0%" / "−4.2%" (Unicode minus).
 * Callers handle the null-baseline case themselves — the tooltip hides it, the
 * data table shows an em-dash.
 */
export function formatSignedPercent(pct: number): string {
  const sign = pct >= 0 ? '+' : '−'
  return `${sign}${Math.abs(pct).toFixed(1)}%`
}

/** Signed change value, formatted per the series' unit, e.g. "+180" / "−42" / "0". */
export function formatSignedValue(delta: number, unit?: MetricUnit): string {
  if (delta === 0) return formatChartValue(0, unit)
  const sign = delta > 0 ? '+' : '−'
  return `${sign}${formatChartValue(Math.abs(delta), unit)}`
}
